
  import createMeisterIcons from '../src/createMeisterIcons';

  const ChevronLeft = createMeisterIcons("chevron-left", [["path",{"fill":"currentColor","d":"M15.18 5.82a.75.75 0 0 1 0 1.06l-5 5a.24.24 0 0 0-.08.17.24.24 0 0 0 .078.168l4.997 4.896a.75.75 0 1 1-1.05 1.072L9.12 13.28a1.716 1.716 0 0 1 0-2.461l5-5a.75.75 0 0 1 1.06 0","key":"81af1f71cc5bf1cfe763dabfa0c4ef00b78698f7","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default ChevronLeft
  